module.exports = __webpack_public_path__ + "static/media/unisw.d4f8acef.png";